import { call, takeLatest } from "redux-saga/effects";
import * as creditApis from "../apis/creditApis";
import {
    CREATE_CREDIT,
    ADD_ROUTE_CREDIT,
    EDIT_ROUTE_CREDIT,
    LIST_CREDIT,
    VIEW_CREDIT,
    ROUTES_LIST_CREDIT,
} from "../actions/types"

export function* createCreditWorker(action) {
    try {
        const res = yield call(creditApis.createCreditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* addRouteCreditWorker(action) {
    try {
        const res = yield call(creditApis.addRouteCreditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editRouteCreditWorker(action) {
    try {
        const res = yield call(creditApis.editRouteCreditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listCreditWorker(action) {
    try {
        const res = yield call(creditApis.listCreditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewCreditWorker(action) {
    try {
        const res = yield call(creditApis.viewCreditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* routesListCreditWorker(action) {
    try {
        const res = yield call(creditApis.routesListCreditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* createCreditWatcher() {
    yield takeLatest(CREATE_CREDIT, createCreditWorker);
}

export function* addRouteCreditWatcher() {
    yield takeLatest(ADD_ROUTE_CREDIT, addRouteCreditWorker);
}

export function* editRouteCreditWatcher() {
    yield takeLatest(EDIT_ROUTE_CREDIT, editRouteCreditWorker);
}

export function* listCreditWatcher() {
    yield takeLatest(LIST_CREDIT, listCreditWorker);
}

export function* viewCreditWatcher() {
    yield takeLatest(VIEW_CREDIT, viewCreditWorker);
}

export function* routesListCreditWatcher() {
    yield takeLatest(ROUTES_LIST_CREDIT, routesListCreditWorker);
}